import { useState, useLayoutEffect } from 'react';

export const useDropdownPosition = (state, inputRef) => {
    const [coords, setCoords] = useState({});

    useLayoutEffect(() => {
        if (!state || !inputRef) {
            return;
        }

        const updatePosition = () => {
            const inputElement = inputRef.current || inputRef;
            if (!inputElement || typeof inputElement.getBoundingClientRect !== 'function') {
                return;
            }
            const rect = inputElement.getBoundingClientRect();
            const dropdownHeight = 350; // default target dropdown height limit
            const viewportHeight = window.innerHeight;
            const viewportWidth = window.innerWidth;

            const spaceBelow = viewportHeight - rect.bottom;
            const spaceAbove = rect.top;

            // Prefer placing above if space below is too small and there is more space above
            const preferAbove = spaceBelow < 250 && spaceAbove > spaceBelow;

            const isRightHalf = rect.left + rect.width / 2 > viewportWidth / 2;

            const style = {
                position: 'fixed',
                zIndex: 9999,
                width: 'max-content',
                minWidth: `${rect.width}px`,
            };

            if (isRightHalf) {
                style.left = 'auto';
                style.right = `${viewportWidth - rect.right}px`;
                style.maxWidth = `${Math.min(rect.right - 10, 500)}px`;
            } else {
                style.left = `${rect.left}px`;
                style.right = 'auto';
                style.maxWidth = `${Math.min(viewportWidth - rect.left - 10, 500)}px`;
            }

            if (preferAbove) {
                style.bottom = `${viewportHeight - rect.top + 2}px`;
                style.top = 'auto';
                style.maxHeight = `${Math.min(spaceAbove - 15, dropdownHeight)}px`;
            } else {
                style.top = `${rect.bottom + 2}px`;
                style.bottom = 'auto';
                style.maxHeight = `${Math.min(spaceBelow - 15, dropdownHeight)}px`;
            }

            setCoords(style);
        };

        updatePosition();

        window.addEventListener('resize', updatePosition);
        // Using capture to catch scrolls anywhere in the layout
        window.addEventListener('scroll', updatePosition, true);

        return () => {
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
        };
    }, [state, inputRef]);

    return coords;
};
